export default __webpack_public_path__ + "static/media/testbanner1.6e80774a.png";